import styled from 'styled-components';
import { layout } from '../../../../../package.json';

interface ContainerProps {
  bJustifyContentCenter?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: ${props => props.bJustifyContentCenter ? 'center' : 'flex-start'};
  align-items: center;
  flex-direction: column;

  background-color: #f4f4f4;
  border-radius: 8px;
  min-height: 400px;
  bottom: 20px;
`;


export const ContainerMethod = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  width: 100%;
  padding: 0 2%;
  height: 60px;
  border: 1px solid var(--primary);
  margin-bottom: 10px;
  border-radius: 10px;

  transition:all 0.6s ease;

  background-color: #FFF;

  span {
    color: var(--primary);
  }
`;


export const ContainerMethodCardData = styled.div`
 display: flex;
 width: 100%;
 div {
   display: flex;
   align-items: center;
   margin-left: 0.25rem;
 }

  @media (max-width: ${layout.desktop}) {
    div > div {
     flex-direction: column;
     align-items: flex-start;
    }
  }
`;

export const ContainerMethodData = styled.div`
 display: flex;
 width: 100%;
 div {
   display: flex;
   align-items: center;
   margin-left: 0.25rem;
 }
`;

export const ContainerPayments = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;

  margin-bottom: 20px;

  width: 100%;
`;

export const AddButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 190px;
  height: 50px;
  cursor: pointer;
  border: 1px solid var(--primary);
  border-radius: 6px;
  background-color: #FFF;
  transition:all 0.6s ease;
  margin-left: 8px;

  span {
    font-size: 18px;
  }
  svg {
    color: var(--btn-finish);
    margin-right: 5px;
  }

  :hover{
    background-color: var(--primary);
    svg {
      color: #FFF;
    }

    span {
      color: #FFF;
    }
  }
`;

export const ButtonContent = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
`;

export const CardButton = styled.div`
  cursor: pointer;
  margin-right: 10px;
  :hover{
      svg {
      color: var(--btn-finish);
    }

  }
`;

export const CardName = styled.div`
  margin-right: 10px;
`;

export const CardNumber = styled.div`
  margin-right: 10px;
`;

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
  flex-direction: row;
  width: 100%;
  margin-bottom: 1rem;

  span {
    font-size: 1.2rem;
  }
`;

export const TitleCashOnDelivery = styled.div`
  display: flex;
  justify-content: center;
  align-items: start;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1rem;
  gap: 5px;

  span {
    font-size: 1.2rem;
  }
`